import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';

// Home de cada perfil — usado quando o acesso a uma rota é negado, para não cair num
// loop de redirecionamento.
export function homeDoPerfil(perfil) {
  if (perfil === 'cliente') return '/catalogo';
  return '/dashboard';
}

export default function PrivateRoute({ children, perfil }) {
  const { user, loading } = useAuth();

  if (loading) return <LoadingSpinner fullPage />;
  if (!user) return <Navigate to="/login" replace />;

  if (perfil) {
    const permitidos = Array.isArray(perfil) ? perfil : [perfil];
    // Gestor é o admin de UMA empresa — passa em toda checagem que operador passa
    // (mesma ideia do backend: get_current_operador_user já inclui gestor).
    const equivalentes = { operador: ['operador', 'gestor', 'admin'], admin: ['admin'] };
    const aceitos = new Set(permitidos.flatMap(p => equivalentes[p] || [p]));
    if (!aceitos.has(user.perfil)) {
      return <Navigate to={homeDoPerfil(user.perfil)} replace />;
    }
  }

  return children;
}
